import { inject, Injectable } from '@angular/core';
import { ROUTE, TeamServiceStrategy } from 'shared';
import { map } from 'rxjs';

@Injectable()
export class BreadcrumbHomeItemService {
  private readonly teamsService = inject(TeamServiceStrategy);

  setDropDownMenuItems() {
    return this.teamsService.getTeams().pipe(
      map(teams => ({
        items: teams.map(team => ({
          id: team.id,
          label: team.name,
          routerLink: `/${ROUTE.teams}/${team.id}`,
          colorSeed: team.id,
        })),
        hasOwnTeam: this.teamsService.hasOwnTeam(teams),
      }))
    );
  }
}
